import { render, staticRenderFns } from "./distributed.vue?vue&type=template&id=5e55aca6&scoped=true"
import script from "./distributed.vue?vue&type=script&lang=js"
export * from "./distributed.vue?vue&type=script&lang=js"
import style0 from "./distributed.vue?vue&type=style&index=0&id=5e55aca6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e55aca6",
  null
  
)

export default component.exports